<template>
  <div class="popular-destinations">
    <div class="popular-destinations__header">
      <slot name="header"></slot>
      <div class="popular-destinations__nav">
        <button class="popular-destinations__nav__btn" @click="prevSlide">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
              d="M5.33331 2.66663L10.3795 7.71278C10.4187 7.74961 10.45 7.7941 10.4714 7.8435C10.4927 7.89288 10.5038 7.94613 10.5038 7.99996C10.5038 8.05379 10.4927 8.10704 10.4714 8.15642C10.45 8.20582 10.4187 8.25031 10.3795 8.28714L5.33331 13.3333" />
          </svg>
        </button>
        <button class="popular-destinations__nav__btn" @click="nextSlide">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
              d="M5.33331 2.66663L10.3795 7.71278C10.4187 7.74961 10.45 7.7941 10.4714 7.8435C10.4927 7.89288 10.5038 7.94613 10.5038 7.99996C10.5038 8.05379 10.4927 8.10704 10.4714 8.15642C10.45 8.20582 10.4187 8.25031 10.3795 8.28714L5.33331 13.3333" />
          </svg>
        </button>
      </div>
    </div>
    <div class="popular-destinations__body">
      <div class="popular-destinations__grid" v-if="ready">
        <carousel :perPage="1" :perPageCustom="perPageCustom" :pagination-enabled="false" ref="carousel">
          <slot name="slides"></slot>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel/src/index.js';
import { getPuplareDestinations } from '../../services/pupular-destinations-list.js';
import Moment from 'moment';

export default {
  data() {
    return {
      destinationList: [],
      ready: false,
      perPageCustom: [
        [
          600,
          2
        ],
        [
          800,
          3
        ],
        [
          1200,
          4
        ]
      ]
    }
  },
  mounted() {
    this.ready = true;
  },
  methods: {
    nextSlide() {
      if (this.$refs.carousel) {
        this.$refs.carousel.handleNavigation('forward');
      }
    },
    prevSlide() {
      if (this.$refs.carousel) {
        this.$refs.carousel.handleNavigation('backward');
      }
    },
    gotoDestination(region_id) {
      let query = {
        fromDate: Moment().set({ hour: 0, minute: 0, second: 0 }).add(1, 'month').format('YYYY-MM-DD'),
        toDate: Moment().set({ hour: 0, minute: 0, second: 0 }).add(1, 'month').add(7, 'days').format('YYYY-MM-DD'),
        departureAirport: 'HAM',
        destinationId: region_id,
        adults: 2,
        childrenCount: 0,
        children: JSON.stringify([]),
        flexibleStartDays: 0,
        flexibleEndDays: 0,
        minPrice: null,
        maxPrice: null
      }

      this.$router.push({
        path: '/hotels',
        query
      });
    }
  },
  components: {
    Carousel,
    Slide
  }
};
</script>